"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATPreloadScene = void 0;
const ATAudioScene_1 = require("./ATAudioScene");
const ATSceneNames_1 = require("./ATSceneNames");
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
class ATPreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super(ATSceneNames_1.default.Preload);
    }
    nextScene() {
        return ATSceneNames_1.default.Menu;
    }
    fontsToLoad() {
        return ["SourceSerif"];
    }
    palette() {
        return [0xFFFFFF, 0x0, 0xFFFFFF];
    }
    loadAssets() {
        super.loadAssets();
        // rexinputtextplugin.min.js
        this.load.svg('volume_on', 'assets/Speaker_Icon.svg', { scale: 1 });
        this.load.svg('volume_off', 'assets/Mute_Icon.svg', { scale: 1 });
        ATAudioScene_1.ATAudioScene.registerClips(this, ATAudioScene_1.ATAudioScene.sfxClips());
    }
    preloadFinished() {
        this.scene.run(ATSceneNames_1.default.Audio);
    }
}
exports.ATPreloadScene = ATPreloadScene;
